'use client';

import { ReactNode } from 'react';
import { Locale } from '@headless-workspace/config';
import { GlowModal, PropsWithClassName, PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { PromotionInformationType, PromotionType } from '../../../../../server';
import { ProductDetailPrice } from './ProductDetailPrice';
import { ProductDetailPricesContainerVariant } from './ProductDetailPricesContainer';
import { PromotionLegalMentionInfo } from './PromotionLegalMentionInfo';

type ProductDetailPricesPromotionProps = PropsWithFontFamily &
    PropsWithClassName & {
        enableDiscountInfo: boolean;
        price?: number;
        currency: string;
        priorPrice?: number;
        pricePerUnit?: string;
        locale: Locale;
        originalPrice?: number;
        discountPercentageLabel?: string;
        promotion?: PromotionType;
        priceAlwaysBlack: boolean;
        displayLegalMentionInformation: boolean;
        promotionInformation?: PromotionInformationType;
        onOpenProductPriceModal?: () => void;
        variant?: ProductDetailPricesContainerVariant;
        isPriceLegalMentionEnabled: boolean;
        VATLegalMentionContent?: ReactNode;
    };

const PRODUCT_DETAIL_PRICES_PROMOTION_ID = 'product-detail-prices-promotion';

export const ProductDetailPricesPromotion: Component<ProductDetailPricesPromotionProps> = ({
    priorPrice,
    price,
    currency,
    locale,
    enableDiscountInfo,
    pricePerUnit,
    fontFamily,
    priceAlwaysBlack,
    originalPrice,
    discountPercentageLabel,
    promotion,
    displayLegalMentionInformation,
    promotionInformation,
    onOpenProductPriceModal,
    variant = 'default',
    isPriceLegalMentionEnabled,
    VATLegalMentionContent,
    className,
}) => {
    return (
        <GlowModal.Content id={PRODUCT_DETAIL_PRICES_PROMOTION_ID} contentClassName={className}>
            <ProductDetailPrice
                price={price}
                locale={locale}
                currency={currency}
                pricePerUnit={pricePerUnit}
                fontFamily={fontFamily}
                promotion={promotion}
                priceAlwaysBlack={priceAlwaysBlack}
                displayLegalMentionInformation={displayLegalMentionInformation}
                variant={variant}
                isPriceLegalMentionEnabled={isPriceLegalMentionEnabled}
            />
            <div className={'flex flex-row items-center gap-1'}>
                <PromotionLegalMentionInfo
                    priorPrice={priorPrice}
                    currency={currency}
                    locale={locale}
                    enableDiscountInfo={enableDiscountInfo}
                    fontFamily={fontFamily}
                    originalPrice={originalPrice}
                    discountPercentageLabel={discountPercentageLabel}
                    promotion={promotion}
                    displayLegalMentionInformation={displayLegalMentionInformation}
                    promotionInformation={promotionInformation}
                    VATLegalMentionContent={VATLegalMentionContent}
                    onOpenProductPriceModal={onOpenProductPriceModal}
                />
            </div>
        </GlowModal.Content>
    );
};
